import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/Login/index'
import index from '@/components/index/main-menu'
import Level2HomePage from '@/components/Level2HomePage/index'
import HomePage from '@/components/HomePage/index'
import Detail from '@/components/Detail/index'
import Cartindex from '@/components/Cart/index'
import Orderindex from '@/components/Cart/order'
import Pro_quotaindex from '@/components/Cart/pro_quota'
import Quick_order from '@/components/Quick_order/index'
import Contract from '@/components/Contract/index'
import Contractdetaile from '@/components/Contract/detaile'
import Deliver from '@/components/Valet_order/index'
import GoodDetail from '@/components/GoodDetail/index'
import Personal from '@/components/Personal/index'
import Customized from '@/components/Customized/index'
import Good_zone from '@/components/HomePage/good_zone'
Vue.use(Router)

export default new Router({
  mode: 'hash',
  base: '/index/',
  routes: [{
      path: '/',
      name: 'HomePage',
      component: HomePage,
    },
    {
      path: '/Login/index',
      name: 'Login',
      component: Login,
    },
    {
      path: '/GoodDetail/index',
      name: 'GoodDetail',
      component: GoodDetail,
    },
    {
      path: '/Level2HomePage/index',
      name: 'Level2HomePage',
      component: Level2HomePage
    },
    {
      path: '/HomePage/detail',
      name: '商品专区',
      component: Good_zone
    },

    {
      path: '/Detail/index',
      name: 'Detail',
      component: Detail
    },
    {
      path: '/index/main-menu',
      name: 'index',
      component: index
    },
    {
      path: '/Personal/index',
      name: 'Personal',
      component: Personal
    },
    {
      path: '/Customized/index',
      name: 'Customized',
      component: Customized
    },


    {
      path: '/Cart/index',
      name: 'cart',
      component: Cartindex
    },
    { //购车列表
      path: '/Cart/order',
      name: 'cart',
      component: Orderindex
    },
    { //申请额度
      path: '/Cart/pro_quota',
      name: 'cart',
      component: Pro_quotaindex
    },
    { //申请额度
      path: '/Quick_order/index',
      name: 'Quick_order',
      component: Quick_order
    },
    { //合同管理
      path: '/Agreement/index',
      name: 'Contract',
      component: Contract
    },
    { //合同管理详情
      path: '/Contract/detaile',
      name: 'Contract',
      component: Contractdetaile
    },
    { //代客下单
      path: '/Deliver/index',
      name: 'Deliver',
      component: Deliver
    },
    { //注册页面
      path: "/Register/index",
      name: "register",
      component: () => import("@/views/Register/index")
    },
    { //促销商品
      path: "/Promotion/index",
      name: "Promotion",
      component: () => import("@/components/Promotion/index")
    },
    { //商家广告
      path: "/advert/index",
      name: "advert",
      component: () => import("@/components/HomePage/advert")
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js